import React, { useEffect, useRef } from 'react';
import flatpickr from 'flatpickr';
import { Link } from 'react-router-dom';

export default function BookingForm() {
  const checkInRef = useRef(null);
  const checkOutRef = useRef(null);

  useEffect(() => {
    const fpIn = flatpickr(checkInRef.current, { dateFormat: 'Y-m-d' });
    const fpOut = flatpickr(checkOutRef.current, { dateFormat: 'Y-m-d' });
    return () => { fpIn.destroy(); fpOut.destroy(); };
  }, []);

  return (
    <div className="checkout-form-section-two">
      <div className="container">
        <div className="checkout-form">
          <div className="checkout-field">
            <h4>Check-In</h4>
            <div className="chk-field">
              <input ref={checkInRef} className="date-pick" type="text" placeholder="31 Dec 2025" readOnly />
              <i className="fas fa-angle-down"></i>
            </div>
          </div>
          <div className="checkout-field">
            <h4>Check-Out</h4>
            <div className="chk-field">
              <input ref={checkOutRef} className="date-pick" type="text" placeholder="31 Dec 2025" readOnly />
              <i className="fas fa-angle-down"></i>
            </div>
          </div>
          <div className="checkout-field select-field br-0">
            <h4>Adult</h4>
            <div className="chk-field">
              <i className="fas fa-angle-down"></i>
              <select className="form-select border-0 py-0">
                {[1,2,3,4,5].map(n => <option key={n}>{n}</option>)}
              </select>
            </div>
          </div>
          <div className="checkout-field select-field br-0">
            <h4>Child</h4>
            <div className="chk-field">
              <i className="fas fa-angle-down"></i>
              <select className="form-select border-0 py-0">
                {[0,1,2,3,4].map(n => <option key={n}>{n}</option>)}
              </select>
            </div>
          </div>
          <Link to="/contact" className="theme-btn btn-style-one">
            <span className="btn-title">CHECK <br />AVAILABILITY</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
